import {AppLinkDto, LinkedLocationNodeType, linkedLocationNodeTypes, IntentType} from '@lib/infrastructure';
import {TFunction} from 'i18next';

export type AppLinkErrorType = {
  title?: string;
  message: string;
  type?: 'notFound' | 'notRecognized';
};

export const validateAppLink = ({id, intent, location}: AppLinkDto, t: TFunction) => {
  const errors: AppLinkErrorType[] = [];

  if (!isIntentRecognized(intent) || !isResourceTypeRecognized(location.nodeType)) {
    errors.push({
      title: t('appLinks:NotRecognizedTitle'),
      message: t('appLinks:NotRecognizedMessage'),
      type: 'notRecognized',
    });
  }

  return errors;
};

const isIntentRecognized = (value: string) => Object.values(IntentType).includes(value as IntentType);
const isResourceTypeRecognized = (value: string) => linkedLocationNodeTypes.includes(value as LinkedLocationNodeType);

export enum NavigationAction {
  Unknown,
  Explore_Controls,
}

export const getNavigationActionFromAppLink = ({intent, location}: AppLinkDto): NavigationAction => {
  // action for explore
  if (intent === IntentType.None || intent === IntentType.ControlBlindsOrTemperature) {
    switch (location.nodeType) {
      case 'MeetingRoom':
      case 'Area':
      case 'Facility':
        return NavigationAction.Explore_Controls;
    }
  }

  return NavigationAction.Unknown;
};
